import { useState } from "react";

/**
 * ADR 355: /live's left column stacks three cards (Localizar, Simulação,
 * Camadas) and the ones below the fold stop being discoverable — the panels
 * collapse to their header instead. Collapsed state is a per-user viewing
 * preference, so it lives in localStorage (same contract as `navCollapsed`):
 * an explicit choice persists, absence falls back to the panel's default.
 *
 * The key is the panel's identity, not the warehouse's — collapsing Simulação
 * is "I don't use this often", which does not change per site.
 */
export function useCollapsedPanel(key: string, defaultCollapsed = false): [boolean, () => void] {
  const storageKey = `twin.panel.${key}`;
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      const v = window.localStorage.getItem(storageKey);
      return v === "1" ? true : v === "0" ? false : defaultCollapsed;
    } catch {
      return defaultCollapsed;
    }
  });
  const toggle = () => {
    setCollapsed((c) => {
      try { window.localStorage.setItem(storageKey, c ? "0" : "1"); } catch { /* storage unavailable */ }
      return !c;
    });
  };
  return [collapsed, toggle];
}
